module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAKlBMVEUAAABicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZkvcHEzAAAADXRSTlMADxrb1sYWy728MR6/xUQdqgAAADdJREFUCNdjQAUrBRgYJBcw9BYyMNY2MKRcFRC9ksDA5hsU6waUVL57WQFIMdkagdXu2cCAHQAAE/MLGR2HaZgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_down.png
// module id = 5X/d
// module chunks = 9